import PropTypes from "prop-types";
import React from "react";
import ReactGA from "react-ga";
import ReactMarkdown from "react-markdown";

import { Link } from "../TrackedLink";

const trackMailToClick = () =>
  ReactGA.event({ category: "Click", action: "MailTo", label: "Link" });

const Markdown = ({ children }) => (
  <ReactMarkdown
    renderers={{
      link: ({ href, children: linkChildren }) =>
        href.indexOf("mailto:") == -1 ? (
          <Link to={href}>{linkChildren}</Link>
        ) : (
          <a onClick={() => trackMailToClick()} href={href}>
            {linkChildren}
          </a>
        ),
    }}
  >
    {children}
  </ReactMarkdown>
);

Markdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Markdown;
